import { Tooltip as MantineTooltip, TooltipProps as MantineTooltipProps } from "@mantine/core";

const Tooltip = ({ ...props }: MantineTooltipProps) => {
  return <MantineTooltip autoContrast={true} {...props} withArrow></MantineTooltip>;
};

export default Tooltip;
